import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a513df22cc2500014ee61c7_1783722211270_30623957/jarvondisu/src/app/professor-portal/page.tsx");
